import { getUser } from '@frontend/auth-helpers';
import { PreferenceKey } from './types';
import { MigrationConfig } from './utils/migration';

const user = getUser();
const STICKY_NOTE_KEY = 'sticky-note';
type StickyColors = 'yellow' | 'green' | 'blue' | 'purple' | 'pink' | 'orange';

export function getStickyNotePrefKey<C extends StickyColors>(color: C) {
  type Capital = Capitalize<C>;

  const capitalColor = (color.charAt(0).toUpperCase() + color.slice(1)) as Capital;

  return {
    currentNoteKey: `StickyNote${capitalColor}CurrentNote` as const,
    archiveKey: `StickyNote${capitalColor}ArchivedNotes` as const,
  };
}

export const migrationConfigs: MigrationConfig[] = [
  {
    localKey: 'ForYouNotificationFilters',
    prefId: 'ForYouNotificationFilters',
    transform: (value) => value.state.forYouNotificationFilters,
  },
  {
    localKey: `${user?.userID}widgetConfigs`,
    prefId: 'WidgetConfigs',
    transform: (value) => value,
  },
  {
    localKey: `${user?.userID}${STICKY_NOTE_KEY}-yellow`,
    prefId: 'StickyNoteYellowCurrentNote',
    transform: (value) => value.currentNote,
    saveLocalKey: true,
  },
  {
    localKey: `${user?.userID}${STICKY_NOTE_KEY}-yellow`,
    prefId: 'StickyNoteYellowArchivedNotes',
    transform: (value) => value.archivedNotes,
  },
  {
    localKey: `${user?.userID}${STICKY_NOTE_KEY}-blue`,
    prefId: 'StickyNoteBlueCurrentNote',
    transform: (value) => value.currentNote,
    saveLocalKey: true,
  },
  {
    localKey: `${user?.userID}${STICKY_NOTE_KEY}-blue`,
    prefId: 'StickyNoteBlueArchivedNotes',
    transform: (value) => value.archivedNotes,
  },
  {
    localKey: `${user?.userID}${STICKY_NOTE_KEY}-green`,
    prefId: 'StickyNoteGreenCurrentNote',
    transform: (value) => value.currentNote,
    saveLocalKey: true,
  },
  {
    localKey: `${user?.userID}${STICKY_NOTE_KEY}-green`,
    prefId: 'StickyNoteGreenArchivedNotes',
    transform: (value) => value.archivedNotes,
  },
  {
    localKey: `${user?.userID}${STICKY_NOTE_KEY}-purple`,
    prefId: 'StickyNotePurpleCurrentNote',
    transform: (value) => value.currentNote,
    saveLocalKey: true,
  },
  {
    localKey: `${user?.userID}${STICKY_NOTE_KEY}-purple`,
    prefId: 'StickyNotePurpleArchivedNotes',
    transform: (value) => value.archivedNotes,
  },
  {
    localKey: `${user?.userID}${STICKY_NOTE_KEY}-pink`,
    prefId: 'StickyNotePinkCurrentNote',
    transform: (value) => value.currentNote,
    saveLocalKey: true,
  },
  {
    localKey: `${user?.userID}${STICKY_NOTE_KEY}-pink`,
    prefId: 'StickyNotePinkArchivedNotes',
    transform: (value) => value.archivedNotes,
  },
  {
    localKey: `${user?.userID}${STICKY_NOTE_KEY}-orange`,
    prefId: 'StickyNoteOrangeCurrentNote',
    transform: (value) => value.currentNote,
    saveLocalKey: true,
  },
  {
    localKey: `${user?.userID}${STICKY_NOTE_KEY}-orange`,
    prefId: 'StickyNoteOrangeArchivedNotes',
    transform: (value) => value.archivedNotes,
  },
  {
    localKey: 'GlobalSearchRecentSearches',
    prefId: 'GlobalSearchRecentSearches',
    transform: (value) => value.state.searches,
  },
  {
    localKey: 'NotificationFilters',
    prefId: 'NotificationFilters',
    transform: (value) => value.state.notificationFilters,
  },
  {
    localKey: 'NotificationSettings',
    prefId: 'NotificationSettings',
    transform: (value) => value.state,
    saveLocalKey: true,
  },
  {
    localKey: 'ForYouNotificationColors',
    prefId: 'ForYouNotificationColors',
    transform: (value) => value.state.forYouNotificationColors,
  },
];

export const LAZY_LOADED_PREFERENCES: PreferenceKey[] = [
  'StickyNoteYellowArchivedNotes',
  'StickyNoteBlueArchivedNotes',
  'StickyNoteGreenArchivedNotes',
  'StickyNotePurpleArchivedNotes',
  'StickyNotePinkArchivedNotes',
  'StickyNoteOrangeArchivedNotes',
];

export const shouldLazyLoad = (preferenceId: PreferenceKey): boolean => {
  return LAZY_LOADED_PREFERENCES.includes(preferenceId);
};
